export const GET_ALL_ICC_CONFIG = `query($first:Int, $last:Int, $after:Cursor, $before:Cursor, $filter: IccEnvironmentConfigurationFilter) {
    allIccEnvironmentConfigurations(first:$first, last:$last, after:$after, before:$before, filter: $filter, orderBy:CREATED_AT_DESC) {
        nodes {
            id
            appAid
            aemEnvironment
            appAid
            clientId
            clientSecret
            iccAppConfigurationId
            iccEnvironment
            localCode
            piapEnvironmentPath
            redirectUrl
            veevaConfigId: veevaEnvironmentConfigurationId
            veevaInstanceType: veevaEnvironmentConfigurationByVeevaEnvironmentConfigurationId {
                veevaInstanceType
            }
            aemCountryNode: veevaEnvironmentConfigurationByVeevaEnvironmentConfigurationId {
              aemCountryNode
            }
            aemHomePageUrl
            aemErrorPagePath
        }
        
        totalCount
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
    }
}`;

export const CREATE_ICC_CONFIG = `mutation($iccEnvironmentConfiguration: IccEnvironmentConfigurationInput!) {
    createIccEnvironmentConfiguration(
        input:{
            iccEnvironmentConfiguration:$iccEnvironmentConfiguration
        }
    ) {
        iccEnvironmentConfiguration{
            id
        }
    }
}`;

export const UPDATE_ICC_CONFIG = `mutation($id: UUID!, $iccEnvironmentConfiguration: IccEnvironmentConfigurationPatch!) { updateIccEnvironmentConfigurationById(input:{
        id: $id,
	    iccEnvironmentConfigurationPatch: $iccEnvironmentConfiguration
    }) {
        iccEnvironmentConfiguration { 
        id
    }}
}`;

export const DELETE_ICC_CONFIG = `mutation($id: UUID!) {
    deleteIccEnvironmentConfigurationById(input:{id: $id}) {
        iccEnvironmentConfiguration {
            id
        }
    }
}`;

export const GET_VEEVA_INSTANCE_COUNTRY = `query($filter: VeevaEnvironmentConfigurationFilter) {
    allVeevaEnvironmentConfigurations(orderBy: CREATED_AT_ASC,filter: $filter){
        nodes {
            id
            country
        }
    }
}`;

export const GET_CONFIG_APP_LIST = `query {
    allIccAppConfigurations {
        nodes {
            id
            appName
        }
    }
}`;
